import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';
import { adminLogin, adminCheckSession, adminTokenLogin, saveAdminRedirectUrl, saveAdminUserType } from '../../../redux/actions/adminActions';
import { changeLanguage } from '../../../redux/actions/userActions';
import { getStoreType, logoController } from '../../../dynamicController';
import { useTranslation } from "react-i18next";

const STORETYPE = getStoreType()

const Login = ({ login, admin, checkSession, location, tokenLogin, themeLogo, saveAdminRedirectUrl, saveAdminUserType, changeLanguage }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const { t } = useTranslation();

    useEffect(() => {
        const { token, redirectUrl, userType, language } = queryString.parse(location.search);
        // console.log({token});
        if (redirectUrl) {
            saveAdminRedirectUrl(redirectUrl)
        }
        if (userType) {
            saveAdminUserType(userType)
        }
        if (language) {
            changeLanguage(language)
        }
        if (token) {
            tokenLogin({ token });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'Loyalty Login',
                'user_id': admin.admin ? admin.admin.username : null,
                'email': admin.admin ? admin.admin.email : null,
                'brand': STORETYPE,
                'role': 'operator'
            })
        } else {
            checkSession(() => console.log("Logged In"));
        }

    }, []);

    const handleSubmit = e => {
        e.preventDefault();
        // console.log({username , password});
        login({ username, password });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Loyalty Login',
            'user_id': username,
            'email': admin.admin ? admin.admin.email : null,
            'brand': STORETYPE,
            'role': 'operator'
        })
    };

    if (admin.isAuthenticated) {
        return <Redirect to="/admin/dashboard" />
    } else {

        return (
            <div className="admin-bgImg">
                <div style={{ height: "100vh", width: "100vw", display: "flex", alignItems: "center" }}>
                    <div id="admin-login">
                        <div id="login-header">
                            <img src={logoController(themeLogo)} alt="main logo" className="img-fluid" />
                            <h4 className="text-left" style={{ color: "#4a536b" }}>{t("Easy")} &amp; {t("Fast Laundromate")}</h4>
                            <h6 className="text-left" style={{ color: "#4a536b" }}>{t("Smart Laundry Management System")}</h6>
                        </div>

                        <div id="login-form">
                            <h4>{t("Login")}</h4>
                            <p>{t("Enter your username and password to login")}</p>

                            {
                                admin.error ? (
                                    <div className={STORETYPE === "cuci" ? "alert alert-warning" : "alert alert-primary"} role="alert">
                                        <strong>{t(admin.error)}</strong>
                                    </div>
                                ) : (null)
                            }

                            <form onSubmit={handleSubmit} className="mt-4">
                                <div className="form-group">
                                    {/* <label htmlFor="username">Username: </label> */}
                                    <input type="text" id="username" name="username" placeholder={t("Username")} className="form-control browser-default" value={username} onChange={e => setUsername(e.target.value)} required />
                                </div>

                                <div className="form-group">
                                    {/* <label htmlFor="password">Password: </label> */}
                                    <input type="password" id="password" name="password" placeholder={t("Password")} className="form-control browser-default" value={password} onChange={e => setPassword(e.target.value)} required />
                                </div>

                                <div className="mt-4">
                                    {
                                        admin.isLoading ? (
                                            <div className="text-center">
                                                <div className={STORETYPE === "cuci" ? "spinner-border text-warning" : "spinner-border text-primary"} role="status">
                                                    <span className="sr-only">Loading ...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <input type="submit" value={t("LOGIN")} className="btn form-control admin-login-button" />
                                        )
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        admin: state.admin,
        themeLogo: state.theme.logo
    };
};

const mapDispatchToProps = dispatch => {
    return {
        login: data => dispatch(adminLogin(data)),
        checkSession: callback => dispatch(adminCheckSession(callback)),
        tokenLogin: token => dispatch(adminTokenLogin(token)),
        saveAdminRedirectUrl: url => dispatch(saveAdminRedirectUrl(url)),
        saveAdminUserType: data => dispatch(saveAdminUserType(data)),
        changeLanguage: (language) => dispatch(changeLanguage(language))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);